module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-hover-bg.c2a047e2.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-hover-bg.png
// module id = 3489
// module chunks = 11